export default {
  Entidade: 1,
  Template: 2,
  Usuario: 3,
  Grupo: 4,
  Departamento: 5,
  Arquivo: 6,
  Empresa: 7,
  Aprovadores: 8,
  Dashboard: 9,
  Alerta: 10,
  Documento: 11,
  GrupoDocumento: 12,
  Log: 13,
  Perfil: 14,
  Relatorio: 15,
  Pendencia: 16,
  Blacklist: 17,
};
